import { useZakeke } from '@zakeke/zakeke-configurator-react';
import { FC } from 'react';
import styled from 'styled-components';
import { ReactComponent as CheckSolid } from '../../assets/icons/check-circle-solid_1.svg';
import { Icon } from 'components/Atomic';
import useStore from 'Store';

const LoadingLabel = styled.div`
	color: #000;
	font-size: 12px;
	font-style: normal;
	font-weight: 700;
	line-height: 16px;
`;

const LoaderContainer = styled.div<{ $isMobile: boolean }>`
	height: 8px;
	${(props) => (props.$isMobile ? `width: 250px` : `width: 600px`)};
	border-radius: 4px;
	background-color: #dbe2e6;
`;

const LoadingPercentageLabel = styled.span`
	color: #8fa4ae;
	font-weight: 400;
	font-size: 12px;
	line-height: 16px;
	font-style: normal;
`;

const LoadingPercentageandIconContainer = styled.div`
	display: flex;
	justify-content: space-between;
`;

const CheckIcon = styled(Icon)`
	cursor: unset;
	color: #008556;
`;

const LoaderFill = styled.div<{ $completed: number; $bgColor: string; $isCompleted: boolean }>`
	height: 100%;
	border-radius: 4px;
	margin: 7px 0px;
	${(props) => `width: ${props.$completed}% `};
	${(props) =>
		props.$bgColor && props.$isCompleted ? `background-color: #008556` : `background-color: ${props.$bgColor}`};
	border-radius: 'inherit';
`;

const ProgressBar: FC<{ $flagStartLoading: boolean; $bgColor: string; $completed: number }> = ({
	$flagStartLoading,
	$bgColor,
	$completed
}) => {
	const { isSceneLoading, T_dynamic, T_static } = useZakeke();
	const { isMobile } = useStore();

	return (
		<div>
			<LoadingLabel>
				{isSceneLoading
					? T_dynamic('Loading your product...')
						? T_dynamic('Loading your product...')
						: T_static('Loading your product...')
					: T_dynamic('Loading complete.')
					? T_dynamic('Loading complete.')
					: T_static('Loading complete.')}
			</LoadingLabel>
			<LoaderContainer $isMobile={isMobile}>
				<LoaderFill
					$completed={!isSceneLoading && $flagStartLoading ? 100 : $completed}
					$bgColor={$bgColor}
					$isCompleted={!isSceneLoading && $flagStartLoading}
				></LoaderFill>
				<LoadingPercentageandIconContainer>
					<LoadingPercentageLabel>
						{isSceneLoading
							? (T_dynamic('In progress | ') ? T_dynamic('In progress | ') : T_static('In progress | ')) +
							  `${$completed}%`
							: '100%'}
					</LoadingPercentageLabel>
					{!isSceneLoading && (
						<CheckIcon>
							<CheckSolid />
						</CheckIcon>
					)}
				</LoadingPercentageandIconContainer>
			</LoaderContainer>
		</div>
	);
};

export default ProgressBar;
